import { memo, useId } from "react";

import { cn } from "@/lib/chillnn/cn";
import { sanitize } from "@/lib/dompurify";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";
import HelpIcon from "@/components/ui/icon/help";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";

import { hotelDraft } from "./constants/hotel";
import { howToBeautiful } from "./constants/how-to";
import { planDraft } from "./constants/plan";
import { roomDraft } from "./constants/room";

type TipsArrayType = {
	id: string;
	title: string;
	article: string;
}[];

export const MagazineEditorTips = memo(() => {
	const array = [
		{ id: useId(), title: "綺麗な記事の書き方", article: howToBeautiful }, //
		{ id: useId(), title: "ホテル紹介", article: hotelDraft }, //
		{ id: useId(), title: "部屋紹介", article: roomDraft }, //
		{ id: useId(), title: "プラン紹介", article: planDraft }, //
	] satisfies TipsArrayType;

	return (
		<Sheet>
			<SheetTrigger className="hidden self-center laptop:block">
				<HelpIcon />
			</SheetTrigger>
			<SheetContent className="w-[670px] max-w-[670px] sm:max-w-none">
				<SheetHeader>
					<SheetTitle>記事の書き方</SheetTitle>
					<SheetDescription>魅力的な記事を作成するためのTips</SheetDescription>
					<div className="pt-4">
						<Accordion type={"single"} collapsible>
							{array.map((item) => {
								return (
									<AccordionItem key={item.id} value={item.id}>
										<AccordionTrigger>{item.title}</AccordionTrigger>
										<AccordionContent className="text-base">
											<div
												className={cn(
													"tiptap ProseMirror", //
													// ホストが管理画面操作中に記事を読みやすくするために記事用のスタイルを一部上書きしている
													"[&>blockquote]:my-2 [&>h3]:mt-0 [&>p]:my-2",
												)}
												dangerouslySetInnerHTML={{
													__html: sanitize(item.article),
												}}
											/>
										</AccordionContent>
									</AccordionItem>
								);
							})}
						</Accordion>
					</div>
				</SheetHeader>
			</SheetContent>
		</Sheet>
	);
});
